export default "__VITE_ASSET__CZsuMKDx__"